import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const formatCurrency = (n) => `TZS ${Number(n).toLocaleString()}`;

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-sm min-w-[160px]">
      <p className="font-semibold text-gray-900 mb-2 border-b border-gray-100 pb-2">
        {label}
      </p>
      {payload.map((p, i) => (
        <p
          key={i}
          style={{ color: p.color || p.fill }}
          className="flex items-center justify-between gap-4 py-1"
        >
          <span className="text-gray-600">{p.name}:</span>
          <span className="font-semibold">{formatCurrency(p.value)}</span>
        </p>
      ))}
    </div>
  );
};

export const DashboardChart = ({ chart = [], timeRange = "monthly" }) => {
  const getXAxisKey = () => {
    if (timeRange === "daily") return "date";
    if (timeRange === "yearly") return "year";
    return "month";
  };

  const xAxisKey = getXAxisKey();

  return (
    <div className="h-[280px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chart}
          margin={{ top: 5, right: 5, left: -15, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#DAE0E7" />
          <XAxis
            dataKey={xAxisKey}
            tick={{ fill: "#67717E", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: "#67717E", fontSize: 12 }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `${(v / 1000000).toFixed(1)}M`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar
            dataKey="sales"
            name="Sales"
            fill="#2248C3"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="purchases"
            name="Purchases"
            fill="#e02020"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DashboardChart;